// Модули
export const USER_DATA = 'userData'
export const SETTINGS = 'settings'
export const PRODUCT = 'product'
export const USERS = 'users'
export const CATEGORY = 'category'
export const WORKING_SHIFT = 'workingShift'
export const REPAIR = 'repair'
export const ONLINE_ORDER = 'onlineOrder'

// Другие данные
export const SALE_NOW = 'saleNow'
